import React, { useEffect, useState } from "react";
import {
  CheckCircleIcon,
  XCircleIcon,
  ExclamationTriangleIcon,
  InformationCircleIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";

const toastStyles = {
  success: {
    icon: CheckCircleIcon,
    wrapper: "border-emerald-100 bg-white",
    iconBox: "bg-emerald-50 text-emerald-600",
    title: "text-emerald-700",
  },
  error: {
    icon: XCircleIcon,
    wrapper: "border-rose-100 bg-white",
    iconBox: "bg-rose-50 text-rose-600",
    title: "text-rose-700",
  },
  warning: {
    icon: ExclamationTriangleIcon,
    wrapper: "border-amber-100 bg-white",
    iconBox: "bg-amber-50 text-amber-600",
    title: "text-amber-700",
  },
  info: {
    icon: InformationCircleIcon,
    wrapper: "border-blue-100 bg-white",
    iconBox: "bg-blue-50 text-blue-600",
    title: "text-blue-700",
  },
};

const AppToast = () => {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    const handleToast = (event) => {
      const toast = event.detail;

      setToasts((prev) => [toast, ...prev].slice(0, 4));

      window.setTimeout(() => {
        setToasts((prev) => prev.filter((item) => item.id !== toast.id));
      }, toast.duration || 4500);
    };

    window.addEventListener("zootel-toast", handleToast);

    return () => {
      window.removeEventListener("zootel-toast", handleToast);
    };
  }, []);

  const removeToast = (toastId) => {
    setToasts((prev) => prev.filter((toast) => toast.id !== toastId));
  };

  if (toasts.length === 0) {
    return null;
  }

  return (
    <div className="fixed top-5 right-5 z-[999999] w-[calc(100%-40px)] max-w-sm space-y-3 pointer-events-none">
      {toasts.map((toast) => {
        const config = toastStyles[toast.type] || toastStyles.info;
        const Icon = config.icon;

        return (
          <div
            key={toast.id}
            className={`pointer-events-auto rounded-[24px] border ${config.wrapper} shadow-2xl shadow-zinc-900/10 overflow-hidden animate-in slide-in-from-right-5 fade-in duration-300`}
          >
            <div className="p-4 flex items-start gap-3">
              <div
                className={`h-11 w-11 rounded-2xl flex items-center justify-center shrink-0 ${config.iconBox}`}
              >
                <Icon className="h-6 w-6 stroke-[2px]" />
              </div>

              <div className="flex-1 min-w-0 pt-0.5">
                {toast.title && (
                  <h4
                    className={`text-sm font-black uppercase tracking-wide ${config.title}`}
                  >
                    {toast.title}
                  </h4>
                )}

                {toast.message && (
                  <p className="text-sm font-semibold text-zinc-600 leading-relaxed mt-0.5">
                    {toast.message}
                  </p>
                )}
              </div>

              <button
                type="button"
                onClick={() => removeToast(toast.id)}
                className="p-1.5 rounded-xl text-zinc-300 hover:text-zinc-900 hover:bg-zinc-50 transition-all shrink-0"
              >
                <XMarkIcon className="h-4 w-4" />
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default AppToast;